export default __webpack_public_path__ + "static/media/actualpic.866e2fd6.png";